export function resolveHasAddOnFromPlans(rawPlans: any[] | undefined, selectedPlanId: string): boolean | null {
  if (!Array.isArray(rawPlans) || !selectedPlanId) return null;

  const selectedPlan = rawPlans.find((plan) => plan?.planId === selectedPlanId);
  if (!selectedPlan) return null;

  const linkedDeclaredAddOns = rawPlans.filter((plan) => plan?.isAddOn === true && plan?.linkedBasePlanId != null);
  if (linkedDeclaredAddOns.length > 0) {
    return linkedDeclaredAddOns.some((plan) => plan.linkedBasePlanId === selectedPlanId);
  }

  const membershipType = selectedPlan?.membershipType;
  return rawPlans.some((plan) => String(plan?.planName ?? "").toLowerCase().includes("pt") && plan?.membershipType === membershipType);
}
